// Typelizer digest fed741cacac66a4f61223ac74d14adde
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** GET /m/pair/:code */
  show: (
    params: { code: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/m/pair/:code', params, options),
    method: 'get',
  }),
}
